import { gql } from '@apollo/client';

const GET_PACKETS = gql`
  query EducatorPackets($where: EducatorPacketsWhereInput) {
    educatorPackets(where: $where) {
      id
      title
      resources {
        id
        title
        url
      }
    }
  }
`;

export default GET_PACKETS;
